// Web bridge handler for renderer process
// This handles communication between web app and desktop app

interface WebMessage {
  type: string;
  payload: unknown;
  id: string;
}

interface WebResponse {
  id: string;
  success: boolean;
  data?: unknown;
  error?: string;
}

class WebBridge {
  private isInitialized = false;

  constructor() {
    this.init();
  }

  private init() {
    if (this.isInitialized) return;

    // Only initialize on client side
    if (typeof window === 'undefined') return;

    // Listen for messages from web app
    window.addEventListener('message', this.handleWebMessage.bind(this));
    this.isInitialized = true;
  }

  private async handleWebMessage(event: MessageEvent) {
    // Only handle messages from the same window (web app)
    if (typeof window === 'undefined' || event.source !== window) return;

    const message = event.data as WebMessage;
    if (!message || !message.type || !message.id) return;

    try {
      let response: WebResponse;

      if (window.electronAPI) {
        // Forward to Electron API
        const result = await window.electronAPI.handleWebMessage(message);
        response = {
          id: message.id,
          success: result.success,
          data: result.data,
          error: result.error,
        };
      } else {
        // No Electron API available
        response = {
          id: message.id,
          success: false,
          error: 'Electron API not available',
        };
      }

      // Send response back to web app
      window.postMessage(response, '*');
    } catch (error) {
      const response: WebResponse = {
        id: message.id,
        success: false,
        error: error instanceof Error ? error.message : 'Unknown error',
      };
      window.postMessage(response, '*');
    }
  }

  public destroy() {
    // Cleanup if needed
  }
}

// Initialize web bridge
export const webBridge = new WebBridge();
